import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'src/shared/components/Input';
import { color, font } from 'src/shared/styles/variables';

interface Props {
    questionId: string;
    questionTitle: string;
    response: number;
    handleResponseChange: (questionId: string, value: number) => void;
}

const options = [...Array(5)].map((_, idx) => ({
    text: `${idx + 1}`,
    value: `${idx + 1}`,
}));

const StyledTitle = styled('span')(
    {
        backgroundColor: color.white,
        paddingRight: 24,
        height: 26,
        lineHeight: '26px',
        color: color.blueBayoux,
    },
    font.medium(font.size.base),
);

const DropdownWrapper = styled('div')({
    marginTop: 0,
    marginBottom: 8,
});

export const ReviewInputNumerical: React.FC<Props> = ({
    questionId,
    questionTitle,
    response,
    handleResponseChange,
}) => {
    const { t } = useTranslation();
    const handleChange = value => {
        handleResponseChange(questionId, Number(value));
    };

    return (
        <div>
            <StyledTitle>{t(questionTitle)}</StyledTitle>
            <DropdownWrapper>
                <Input
                    type="single-select-dropdown"
                    value={`${response || t('intakeForms:review_numerical.no_response')}`}
                    options={options}
                    fieldId={questionId}
                    onChange={handleChange}
                />
            </DropdownWrapper>
        </div>
    );
};
